import { getEndpoint } from './endpoints';

export const refControls = {
    state: {
        controls: [],
        control: null,
    },
    mutations: {
        setControls(state, payload) {
            state.controls = payload;
        },
        setControl(state, payload) {
            state.control = payload;
        },
    },
    actions: {
        async fetchControls({ commit, rootState }, payload) {
            const endpoint = getEndpoint('controls', payload.id).controls;

            const { data } = await rootState.app.http.instance.get(endpoint);

            commit('setControls', data);
        },
        async fetchControl({ commit, rootState }, payload) {
            const endpoint = getEndpoint('controls', payload.propertyId, payload.controlId).control;

            const { data } = await rootState.app.http.instance.get(endpoint);

            commit('setControl', data);
        },
    },
    getters: {
        getControls(state) {
            return state.controls;
        },
        getControl(state) {
            return state.control;
        },
    },
};
